export enum HlaGeneGroup {
    Class1 = 0,
    Drb = 1,
    Dqa = 2,
    Dqb = 3,
    Dpa = 4,
    Dpb = 5
}